module.exports = __webpack_public_path__ + "img/character_default.338116f1.svg";